// extracted by mini-css-extract-plugin
module.exports = {"previousButton":"az_WVc","previousButtonImage":"az_XVc","nextButton":"az_YVc"};